export default "__VITE_ASSET__C6$q5zcb__"